import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {Details} from '../details/details';
import {EventLogsService} from '../services/event-logs.service';
import {LoadingService} from '../services/loading.service';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {SalePointsService} from '../services/sale-points.service';

@Component({
  templateUrl: './sale-point-version-details.component.html'
})
export class SalePointVersionDetailsComponent extends Details implements OnInit {
  public basicDetailsConfig: any;
  public eventLogs: any[];
  public initializePage: boolean;
  public mainDataSections: any[];
  public previousDataSections: any[];
  public salePoint: any;
  public previousSalePoint: any;
  public eventLogID: number;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              private commonService: CommonService,
              private eventLogsService: EventLogsService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private salePointsService: SalePointsService,
              private router: Router) {
    super();
  }

  public ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      let promises: Array<Promise<any>>;
      this.eventLogID = +params.get('id');

      promises = [];
      const promise1 = this.salePointsService.getSingleSalePointPreviousVersion(+params.get('id')).then((salePoints) => {
        this.previousSalePoint = salePoints.previousSalePoint;
        this.salePoint = salePoints.currentSalePoint;
      });
      promises.push(promise1);

      if (this.showEventLogs()) {
        const promise2 = this.eventLogsService.getSingleEventLog(+params.get('id')).then((eventLogs) => {
          this.eventLogs = eventLogs;
        });
        promises.push(promise2);
      }

      Promise.all(promises).then(() => {
        this.basicDetailsConfig = {
          showActions: false,
          status_name: this.salePoint.is_active ? 'Ενεργό' : 'Ανενεργό',
          status_value: this.salePoint.is_active,
          subtitle: [
            {
              title: 'Α.Φ.Μ.',
              value: this.salePoint.vat_number
            }
          ],
          title: `Πληροφορίες Σημείου Πώλησης: ${this.salePoint.customer_name}`
        };

        this.checkValues(this.salePoint, this.previousSalePoint);

        this.mainDataSections = this.salePointsService.initializeSalePoint(this.salePoint, this.previousSalePoint);
        this.previousDataSections = this.salePointsService.initializeSalePoint(this.previousSalePoint);
        this.eventLogID = this.eventLogs && this.eventLogs.length > 0 ? this.eventLogs[0].id : this.eventLogID;
        this.initializePage = true;

        this.loadingService.hide();
      });
    });
  }

  private checkValues(currentSalePoint, previousSalePoint) {
    for (const [key, value] of Object.entries(previousSalePoint)) {
      if (currentSalePoint[key]) {
        const result = `${currentSalePoint[key]}`;
        const result0 = `${value}`;
        const result1 = result === result0;
        console.log(result1);
      } else {
        console.log('no');
      }
    }
  }

  public showEventLogs(): boolean {
    return this.authService.isUserBelongsTo('basicUser') ||
      this.authService.isUserBelongsTo('transportManager') ||
      this.authService.isUserBelongsTo('customerManager');
  }

  protected showActions(): boolean {
    return false;
  }

}
